export default __webpack_public_path__ + "static/media/hungry.fe000803.png";